import { memo, useCallback, useMemo } from "react";

import { BlankContentForList } from "@/components/features/_components";
import { StockDailyItemMobile } from "@/components/features/items/stock/_shared/components/mobile/daily-item";

import { useOptionStockTablePresenter } from "./hooks/use-option-table-presenter";

import type { OptionStockDiffStore } from "../../../../../model/usecase/use-create-form-model/option-stock-diff-store";
import type { ServerModel } from "../../../../../model/usecase/use-create-form-model/type";

type Props = {
	serverModel: ServerModel;
	optionStockDiffStore: OptionStockDiffStore;

	selectedItemIDs: string[];
};

export const OptionStockTableForMobile = memo(({ serverModel, optionStockDiffStore, selectedItemIDs }: Props) => {
	const { filteredOptionStock } = useOptionStockTablePresenter({
		serverModel,
		selectedItemIDs,
	});

	/**
	 * 在庫一覧を表示するか
	 */
	const canShowStockList = useMemo(() => filteredOptionStock.items.length > 0, [filteredOptionStock.items.length]);

	const onSetOptionItemStock = useCallback(
		(input: { optionID: string; subOptionID: string | undefined; date: string }) =>
			(isAvailable: boolean, remainNum: number) => {
				optionStockDiffStore.put({
					optionID: input.optionID,
					subOptionID: input.subOptionID,
					date: input.date,
					isAvailable,
					remainNum,
				});
			},
		[optionStockDiffStore],
	);

	return (
		<div>
			{canShowStockList ? (
				<div>
					{filteredOptionStock.items.map((item) => {
						const key = item.subOptionID ?? item.optionID;

						return (
							<div key={key} className="space-y-4">
								{item.stocks.map((stock, idx) => {
									return (
										<StockDailyItemMobile
											key={`${key}-${stock.date}-${idx}`}
											stockDailyItem={stock}
											onSetStock={onSetOptionItemStock({
												optionID: item.optionID,
												subOptionID: item.subOptionID ?? undefined,
												date: stock.date,
											})}
											itemName={item.name}
										/>
									);
								})}
							</div>
						);
					})}
				</div>
			) : (
				<BlankContentForList content="表示するオプションがありません。" />
			)}
		</div>
	);
});

OptionStockTableForMobile.displayName = "OptionStockTableForMobile";
